if (!customElements.get('product-callouts')) {
  
  customElements.define(
    
    'product-callouts',
    
    class ProductCallouts extends HTMLElement {
      
      constructor() {
        super();
        
        this.wrapper = this;
        this.hoverClass = 'hover';
        
        this.querySelectorAll('.callout-trigger').forEach((trigger) => {
          
          const id = trigger.dataset.calloutId;
          
          trigger.addEventListener('click', (event) => {
            this.onClick(event, id);
          });
          
          trigger.addEventListener('mouseover', () => {
            this.onMouseOver(id);
          });
          
          trigger.addEventListener('mouseout', () => {
            this.onMouseOut(id);
          });
        });
      }
      
      onClick(event, id) {
        event.preventDefault();
        
        const triggers = this.getTriggersByCalloutId(id);
        if (triggers) {
          
          if (triggers[0].getAttribute('aria-expanded') == 'true') {
            triggers.forEach((trigger) => {
              trigger.setAttribute('aria-expanded', 'false');
            });
          }
          else {
            this.closeOpenElements();
            triggers.forEach((trigger) => {
              trigger.setAttribute('aria-expanded', 'true');
            });
          }
          
        }
      }
      
      onMouseOver(id) {
        
        const triggers = this.getTriggersByCalloutId(id);
        
        if (triggers) {
          triggers.forEach((trigger) => {
            trigger.classList.add(this.hoverClass)
          });
        }
      }
      
      onMouseOut(id) {
        
        const triggers = this.getTriggersByCalloutId(id);
        
        if (triggers) {
          triggers.forEach((trigger) => {
            trigger.classList.remove(this.hoverClass)
          });
        }
      }
      
      getTriggersByCalloutId(id) {
        return this.wrapper.querySelectorAll(`.callout-trigger-${ id }`);
      }
      
      closeOpenElements() {
        
        this.querySelectorAll('.callout-trigger[aria-expanded=true]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
    }
  );
}